import {
  MockMap,
} from '@ama-sdk/core';
import {
  AcceptanceRepository,
  combineCheckInBaggagePolicies,
  createAcceptance,
  createJourneyElement,
  createJourneyElementCommon,
  createMockData,
  createMockDataWithResponse,
  MockAcceptance,
  MockJourneyElementCommon,
  todayPlusNdays,
} from '@dapi/sdk/spec';
import {
  authorization,
  namedTraveler,
} from '../../mock';
import {
  acceptedMultiLegJourney,
  chargeableSeatsToPayForMultiLegJourney,
  defaultCheckInBaggagePolicies,
  firstCHSeatOnMultiLegJourney,
  firstExitRowSeatOnMultiLegJourney,
  firstFreeSeatOnMultiLegJourney,
  multiLegBoardingPassResultForDifferentSeats,
  multiLegBoardingPassResultForSameChargeableSeats,
  multiLegBoardingPassResultForSameFreeSeats,
  multiLegDifferentFreeSeatsUpdateResponse,
  multiLegJourneys,
  multiLegSameChargeableSeatsUpdateResponse,
  multiLegSameFreeSeatsUpdateResponse,
  multiLegSeatmap,
  noItemToPayError,
  paymentRecords,
} from '../../mock/data';

/**
 * OW Multileg 1Journey
 * 1ADT
 * Chargeable and free seats journey
 */
const checkedInJourneyElementFirstSeat: MockJourneyElementCommon = createJourneyElementCommon({
  template: {
    journeyElement: createJourneyElement({
      template: {
        checkInStatus: 'accepted',
        traveler: namedTraveler,
        travelerId: namedTraveler.id,
        seat: firstExitRowSeatOnMultiLegJourney,
        legs: [
          {
            boardPointIataCode: 'NCE',
            offPointIataCode: 'CDG',
            scheduledArrivalDateTime: todayPlusNdays('9:20', 2),
            scheduledDepartureDateTime: todayPlusNdays('9:00', 2),
            seat: firstFreeSeatOnMultiLegJourney[0]
          },
          {
            boardPointIataCode: 'CDG',
            offPointIataCode: 'LHR',
            scheduledArrivalDateTime: todayPlusNdays('10:00', 2),
            scheduledDepartureDateTime: todayPlusNdays('9:30', 2),
            seat: firstFreeSeatOnMultiLegJourney[0]
          }
        ]
      }
    })
  }
});
const acceptance: MockAcceptance = createAcceptance({
  template: {
    checkedInJourneyElements: [checkedInJourneyElementFirstSeat],
    isAccepted: true
  }
});

export const owMultiLeg1Journey1AdtChargeableAndFreeSeats: MockMap = {
  authorizeJourneyPaymentRecord: [createMockData(authorization)],
  confirmJourneyPaymentRecord: [createMockData(paymentRecords)],
  createJourneyPaymentRecord: [createMockData(paymentRecords)],
  generateBoardingPasses: [
    createMockDataWithResponse(multiLegBoardingPassResultForSameChargeableSeats, 201),
    createMockDataWithResponse(multiLegBoardingPassResultForSameChargeableSeats, 201),
    createMockDataWithResponse(multiLegBoardingPassResultForSameFreeSeats, 201),
    createMockDataWithResponse(multiLegBoardingPassResultForSameFreeSeats, 201),
    createMockDataWithResponse(multiLegBoardingPassResultForDifferentSeats, 201),
    createMockDataWithResponse(multiLegBoardingPassResultForDifferentSeats, 201)
  ],
  getBaggagePoliciesFromJourney: [createMockData(combineCheckInBaggagePolicies([defaultCheckInBaggagePolicies]).items)],
  getJourneyUnpaidItems: [
    createMockData(chargeableSeatsToPayForMultiLegJourney),
    createMockData(chargeableSeatsToPayForMultiLegJourney),
    createMockData(chargeableSeatsToPayForMultiLegJourney),
    createMockData(chargeableSeatsToPayForMultiLegJourney),
    createMockData(noItemToPayError),
    createMockData(noItemToPayError),
    createMockData(noItemToPayError),
    createMockData(noItemToPayError),
    createMockData(noItemToPayError),
    createMockData(noItemToPayError),
    createMockData(noItemToPayError),
    createMockData(noItemToPayError),
    createMockData(noItemToPayError),
    createMockData(noItemToPayError),
    createMockData(noItemToPayError),
    createMockData(noItemToPayError)
  ],
  assignSeatToJourneyElement: [
    createMockDataWithResponse(firstCHSeatOnMultiLegJourney[0], 201)
  ],
  updateJourneySeats: [
    createMockData(multiLegSameFreeSeatsUpdateResponse),
    createMockData(multiLegDifferentFreeSeatsUpdateResponse)
  ],
  updateJourneyElement: [
    createMockData(multiLegSameChargeableSeatsUpdateResponse)
  ],
  requestAcceptanceOfJourney: [
    createMockDataWithResponse(AcceptanceRepository.TWO_SECURITY_QUESTIONS, 201),
    createMockDataWithResponse(acceptance, 201),
    createMockDataWithResponse(acceptance, 201)
  ],
  retrieveJourneyBaggages: [createMockData([])],
  retrieveJourneys: [
    createMockDataWithResponse(multiLegJourneys, 201),
    createMockDataWithResponse([acceptedMultiLegJourney], 201)
  ],
  retrieveJourney: [
    createMockData({
      ...acceptedMultiLegJourney,
      journeyElements: [checkedInJourneyElementFirstSeat]
    })
  ],
  retrieveSeatMapsJourneyDriven: [createMockData(multiLegSeatmap)]
};
